import store from 'store'

import { useAppQuery } from 'hooks/use-app-query'
import { getCountries, getStatesByCountryId } from 'services/country'
import { STALE_TIME } from 'utils/constants'
import { addressLookupKey } from 'utils/constants/queryKey'

const useCountries = () => {
  const currentBranchId = store.getState().user.selectedBranch?.id ?? ''

  return useAppQuery(addressLookupKey.countries(), getCountries, {
    staleTime: STALE_TIME.masterSetting,
    enabled: Boolean(currentBranchId),
  })
}

const useCountryStates = (countryId: number | null) =>
  useAppQuery(addressLookupKey.state(countryId ?? 0), () => getStatesByCountryId(countryId ?? 0), {
    enabled: !!countryId,
    staleTime: STALE_TIME.masterSetting,
  })

export { useCountries, useCountryStates }
